document.addEventListener('DOMContentLoaded', function () {
  window.BuildYou = {
    ...window.BuildYou,
    cartTransformEnabled: false,
  }
  let isPersonalizationProduct = false;
  window.addEventListener('customily-properties-generated', (e) => {
    const { detail } = e;
    const data = preprocessAddToCartData(detail);
    addToCart(data);
  });

  window.addEventListener('options-state-updated', (e) => {
    isPersonalizationProduct = false;
  });

  if (!window.tfxProduct || !window.tfxProduct.variants) return;

  const isCustomPhoto = window.tfxProduct.title.toLowerCase().includes('custom photo');
  let customilyLoadersShownHandled = false;

  setupQuantityControls();
  bindCustomilyEvents();
  handleCustomilyAddToCart();

  // setupCustomilyLogging(); // [Customily Event Debugging]
  handlePersonalizationFormInputs();

  function setupQuantityControls(containerSelector = '.product-qty-snippet') {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    const input = container.querySelector('.qty-value');
    const btnMinus = container.querySelector('.qty-minus');
    const btnPlus = container.querySelector('.qty-plus');

    const setQuantity = (qty) => {
      const val = Math.max(1, parseInt(qty, 10) || 1);
      input.value = val;
      const quantityChangeEvent = new CustomEvent('product:quantity-change', { detail: { quantity: val } });
      window.dispatchEvent(quantityChangeEvent);
    };

    btnMinus?.addEventListener('click', () => setQuantity((parseInt(input.value) || 1) - 1));
    btnPlus?.addEventListener('click', () => setQuantity((parseInt(input.value) || 1) + 1));
    input?.addEventListener('input', (e) => setQuantity(e.target.value));
  }

  function bindCustomilyEvents() {
    handleCustomilyAppWillLoad();
    handleCustomilyLivePreviewShown();
    handleCustomilyPreviewModalShow();
    handleCustomilyProductLoaded();
    handleCustomilyLoadersShown();
    handleCustomilyPropertiesGenerated();
  }

  function handleCustomilyLivePreviewShown() {
    window.addEventListener('customily-live-preview-shown', () => {
      const swiperContainer = document.querySelector('.swiper--container');
      const indexWrapper = document.querySelector('.product-gallery-index-wrapper');
      indexWrapper?.remove();
      swiperContainer?.classList.remove('md:wp-w-[calc(100%-96px)]');
      const thumbnailNavigator = document.getElementById('thumb-navigator');
      thumbnailNavigator?.remove();
      window.__swiper?.destroy();
    });
  }

  function handleCustomilyPreviewModalShow() {
    window.addEventListener('customily-preview-modal-show', () => {
      const modal = document.querySelector('.customily-modal-preview-only');
      const originalBtn = document.getElementById('customily-cart-btn');
      if (modal && originalBtn) {
        const targetEl = modal.querySelector('.main');
        if (targetEl && !targetEl.querySelector('#customily-bottom-wrapper')) {
          const clonedBtn = originalBtn.cloneNode(true);
          const wrapperDiv = document.createElement('div');
          wrapperDiv.id = 'customily-bottom-wrapper';
          wrapperDiv.className = 'wp-bg-white wp-p-3 wp-flex wp-justify-center wp-w-full wp-rounded-b-2xl';
          clonedBtn.addEventListener('click', () => {
            clonedBtn.classList.add('running');
            originalBtn.click();
          });
          wrapperDiv.appendChild(clonedBtn);
          targetEl.appendChild(wrapperDiv);
        }
      }
      if (window.screen.width <= 768 && isCustomPhoto) {
        setTimeout(() => {
          const modalCloseBtn = document.querySelector('.customily-close-button.cl-is-mobile');
          modalCloseBtn.addEventListener('click', () => handleClosePreviewModalMobile());
          const previewWrapper = document.querySelector('.cl-preview-wrapper');
          const canvasWrapperEl = document.querySelector('.canvas-wrapper');
          if (previewWrapper && canvasWrapperEl) {
            previewWrapper.innerHTML = '';
            previewWrapper.appendChild(canvasWrapperEl);
          }
        }, 300);
      }
    });
  }

  function handleCustomilyProductLoaded() {
    window.addEventListener('customily-product-loaded', () => {
      const previewModal = document.querySelector('.customily-modal-preview-only');
      const closeButtonModal = document.querySelector('.customily-close-button');
      const modalEl = document.querySelector('.customily-modal-preview-only .main');
      const canvasContainerEl = document.querySelector('.cl-canvas-container');
      const canvasWrapperEl = document.querySelector('.canvas-wrapper');
      closeButtonModal.addEventListener('click', (e) => {
        e.stopPropagation();
        if (canvasContainerEl && canvasWrapperEl) {
          canvasContainerEl.appendChild(canvasWrapperEl);
        }
      });
      previewModal.addEventListener('click', (e) => {
        let target = e.target;
        if (target !== modalEl && !modalEl.contains(target) && canvasContainerEl && canvasWrapperEl) {
          canvasContainerEl.appendChild(canvasWrapperEl);
        }
      });
    });
  }

  function handleClosePreviewModalMobile() {
    if (window.screen.width <= 768 && isCustomPhoto) {
      const rootCanvasWrapper = document.querySelector('.cl-canvas-container');
      const canvasWrapperEl = document.querySelector('.canvas-wrapper');
      if (rootCanvasWrapper && canvasWrapperEl) {
        rootCanvasWrapper.appendChild(canvasWrapperEl);
      }
    }
  }

  function handleCustomilyLoadersShown() {
    window.addEventListener('customily-loaders-shown', () => {
      if (customilyLoadersShownHandled) return;
      customilyLoadersShownHandled = true;
      const customilyForm = document.getElementById('customily-options');
      if (!customilyForm || customilyForm.closest('.customily-form-wrapper')) return;
      const loadingEl = document.getElementById('loading-personalize');
      if (loadingEl) loadingEl.remove();
      const elModalUploadGuild = document.querySelector('#modal-upload-guild');
      const customilyFormWrapper = document.createElement('div');
      const uploadGuildLine = document.createElement('div');
      const textGuildLine = document.createElement('div');
      const imgGuildLine = document.createElement('img');
      uploadGuildLine.className = 'wp-flex wp-gap-1 wp-cursor-pointer wp-hidden';
      uploadGuildLine.id = 'text-upload-guild';
      imgGuildLine.className = 'wp-text-secondary';
      imgGuildLine.src =
        'https://cdn.shopify.com/s/files/1/0949/1454/3899/files/icon.question-mark-blue.svg?v=1750741641';
      imgGuildLine.width = '16';
      imgGuildLine.height = '16';
      imgGuildLine.alt = 'View photo upload guidelines here';
      textGuildLine.className = 'wp-text-sm wp-text-[#007db5] wp-my-2 wp-w-fit';
      textGuildLine.innerText = 'View photo upload guidelines here';
      if (isCustomPhoto) {
        uploadGuildLine.classList.remove('wp-hidden');
        uploadGuildLine.addEventListener('click', () => {
          elModalUploadGuild.classList.remove('wp-hidden');
        });
      }
      uploadGuildLine.appendChild(imgGuildLine);
      uploadGuildLine.appendChild(textGuildLine);
      customilyFormWrapper.className =
        'customily-form-wrapper wp-rounded-lg wp-border-gray-500 wp-p-2.5 wp-bg-light-gray';
      const customilyFormTitle = document.createElement('p');
      customilyFormTitle.innerText = 'Personalized Options';
      customilyFormTitle.className =
        'wp-text-center wp-my-1 wp-border-b wp-border-[#cccccc] wp-py-1 wp-font-semibold wp-text-base wp-leading-6';
      customilyForm.parentNode.insertBefore(customilyFormWrapper, customilyForm);
      customilyFormWrapper.appendChild(customilyFormTitle);
      customilyFormWrapper.appendChild(uploadGuildLine);
      customilyFormWrapper.appendChild(customilyForm);
    });
  }

  function handleCustomilyPropertiesGenerated() {
    window.addEventListener('customily-properties-generated', () => {});
  }

  function handleCustomilyAppWillLoad() {
    window.addEventListener('customily-app-will-load', () => {
      isPersonalizationProduct = true;
      const loadingEl = document.getElementById('loading-personalize');
      if (loadingEl) {
        loadingEl.classList.add('wp-flex');
        loadingEl.classList.remove('wp-hidden');
      }
    });
  }

  function setupCustomilyLogging() {
    const customilyEvents = [
      'customily-app-will-load',
      'customily-app-wont-load',
      'customily-modal-show',
      'customily-modal-close',
      'customily-preview-modal-show',
      'customily-preview-modal-hide',
      'customily-options-toggle',
      'customily-options-collapse',
      'customily-share-customization',
      'customily-loaders-shown',
      'customily-loaders-hidden',
      'customily-show-loaders',
      'customily-hide-loaders',
      'customily-save-customization',
      'customily-save-customization-ready',
      'customily-update-customization',
      'customily-load-customization-started',
      'customily-load-customization-finished',
      'customily-options-loaded',
      'customily-options-changed',
      'customily-preview-load-started',
      'customily-preview-load-finished',
      'customily-pricing-change',
      'customily-image-uploaded',
      'customily-required-error',
      'customily-check-conditions',
      'customily-variant-stock',
      'customily-live-preview-show-canvas',
      'customily-live-preview-hide-canvas',
      'customily-live-preview-shown',
      'customily-live-preview-hidden',
      'customily-properties-generated',
      'customily-vector-uploaded',
      'customily-add-addons-error',
      'customily-variation-change-started',
      'customily-variation-change-finished',
      'customily-canvas-rendered',
      'customily-starts-adding-to-cart',
      'customily-add-to-cart-completed',
      'customily-update-cart-item-completed',
      'customily-trigger-add-to-cart',
      'customily-page-reloaded',
      'customily-zoom-in-object',
      'customily-zoom-out',
      'customily-zoom-out-clear',
      'customily-shadow-root-reflected',
      'customily-trigger-cart-iterate',
    ];

    function logEvent(e) {
      console.log(`[CUSTOMILY EVENT]: ${e.type}`);
    }

    window.addEventListener('customily-app-will-load', () => {
      console.log('[INFO] Bắt đầu theo dõi Customily events...');
      customilyEvents.forEach((eventName) => {
        window.addEventListener(eventName, logEvent);
      });
    });
  }

  function handleCustomilyAddToCart() {
    const customilyForm = document.querySelector('form.personalization-form');
    if (!customilyForm) return;

    customilyForm.addEventListener('submit', async (e) => {
      if (isPersonalizationProduct) {
        e.preventDefault();
      }
    });
  }

  async function addToCart(data) {
    const cart_add_url = window.Shopify.routes.cart_add || "/cart/add.js";
    const response = await fetch(cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .catch((err) => console.error(err));
    if (response) {
      const previewDialogCloseBtn = document.querySelector('.customily-close-button');
      if (previewDialogCloseBtn) {
        previewDialogCloseBtn.click();
      }
      const atcBtn = document.querySelectorAll('.atc-btn-custom');
      atcBtn.forEach((btn) => btn.classList.remove('running'));
      const addCartSuccessEvent = new CustomEvent('cart:added', { detail: response });
      window.dispatchEvent(addCartSuccessEvent);
    }
    return response;
  }

  function preprocessAddToCartData(properties) {
    const customilyForm = document.querySelector('form.personalization-form');
    if (!customilyForm) return;

    const formData = new FormData(customilyForm);
    const dataForm = Object.fromEntries(formData);

    const addons = (Array.isArray(window.ebUpsell) ? window.ebUpsell : []).filter((obj) => obj && obj.id);
    const isBundle = Boolean(dataForm?.id) && addons.length > 0;

    if (!isBundle) {
      const mainItem = { ...dataForm };
      const data = { items: [mainItem] };
      for (const key in properties) {
        if (Object.prototype.hasOwnProperty.call(properties, key)) {
          if (!mainItem.properties) mainItem.properties = {};
          mainItem.properties[key] = properties[key];
        }
      }
      return data;
    }

    const groupId = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : Date.now() + '-' + Math.random().toString(36).slice(2, 10);

    const mainItem = {
      ...dataForm,
      properties: {
        ...properties,
        _bundle_group: groupId,
        _bundle_role: 'main',
        _bundle_item_index: '0',
      },
    };

    const addonItems = addons.map((obj, idx) => ({
      id: obj.id,
      quantity: Math.max(1, parseInt(obj.quantity, 10) || 1),
      properties: {
        _bundle_group: groupId,
        _bundle_role: 'addon',
        _bundle_item_index: String(obj.index || idx + 1),
      },
    }));

    return { items: [...addonItems.reverse(), mainItem] };
  }

  function handlePersonalizationFormInputs() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        const target = e.target;
        if (target.tagName === 'INPUT') {
          const form = target.closest('form');
          if (form && form.classList.contains('personalization-form')) {
            e.preventDefault();
            return false;
          }
        }
      }
    });
  }
});
